<template>
  <div class="container-become-agent" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top: ${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.BecomeAgent.k005') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="logo">
        <img :src="getMatchImg('app-logo')" alt="" />
        <span>{{ $t('lang.BecomeAgent.k005') }}!</span>
      </div>
      <div class="item">
        <div class="text">1.{{ $t('lang.BecomeAgent.k006') }}</div>
        <input type="text" v-model="youFrom" />
      </div>
      <div class="item">
        <div class="text">2.{{ $t('lang.BecomeAgent.k007') }}</div>
        <input type="text" :placeholder="$t('lang.BecomeAgent.k002')" v-model="theyFrom" />
      </div>
      <div class="item">
        <div class="text">3.{{ $t('lang.BecomeAgent.k008') }}</div>
        <input type="text" :placeholder="$t('lang.BecomeAgent.k003')" v-model="contact" />
      </div>
      <div class="item">
        <div class="text">4.{{ $t('lang.BecomeAgent.k009') }}</div>
        <van-uploader
          v-show="s3"
          :after-read="afterRead"
          v-model="fileList"
          :max-count="5"
          @delete="(file, detail) => deleteImg(file, detail)"
          :multiple="multiple"
        />
      </div>
      <!-- prettier-ignore -->
      <div
        v-if="this.code"
        :class="{ submit: true, submitflag: youFrom && theyFrom && contact && flag && fileList.length > 0 }"
        @click="handleSubmit"
      >
        <span v-if="codeFlag">{{ $t('lang.BecomeAgent.k001') }}</span>
        <span v-else>{{ $t('lang.BecomeAgent.k004') }}</span>
        <van-loading v-if="isSubmitting" class="submit-loading" type="spinner" color="#ffffff" size="18px" />
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchUserAccountInfo, apiAgentApply, getAwsInfoApi } from '@/api/imee.js'
import { decryptCode } from '@/utils/common.js'
import { getBaseFeature } from '@/assets/style/variable'

import SecretKey from '@/config/secret-key.js'
import AWS from 'aws-sdk'

export default {
  data() {
    return {
      youFrom: null,
      theyFrom: null,
      contact: null,
      fileList: [],
      s3: null,
      suffix: '',
      fileName: '',
      fileUpload: null,
      // 防止重复点击
      loading: false,
      // 后端需要的图片参数
      fileUploadImgList: [],
      status: '',
      code: '',
      codeFlag: false,
      flag: false,

      isSubmitting: false,
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    // 获取用户信息
    fetchUserAccountInfo() {
      apiFetchUserAccountInfo().then((res) => {
        this.code = res.locationCode
        this.codeFlag = ['BR', 'CO', 'VE', 'AR', 'CL', 'EC', 'ES', 'UY', 'MX', 'PE', 'PT'].includes(this.code)
      })
    },

    afterRead(e) {
      e.status = 'uploading'
      const that = this
      const file = e.file

      if (file) {
        try {
          that.fileName = file.name
          that.loading = true
          const key = 'public/picture/agent/' + that.getUid() + '_' + file.lastModified + '/' + that.fileName

          const params = {
            Bucket: 'relationcoachf70d843ba0934dfebf4f63dcdb5f9158102154-dev',
            Key: key,
            Body: file,
          }

          that.fileUpload = that.s3.upload(params, function (err, data) {
            if (err) {
              that.fileList.length = 0
              that.loading = false
              that.flag = false
              return
            }

            e.status = 'done'
            that.flag = true
          })
        } catch (err) {
          that.fileList.length = 0
          that.loading = false
          that.flag = false
        }
      }
    },
    deleteImg(file, detail) {
      if (this.fileList.length == 0) {
        this.flag = false
      }
    },
    // 提交
    handleSubmit() {
      // 防止重复提交
      if (this.isSubmitting) {
        return
      }

      if (this.fileList.length == 0) {
        return
      }

      this.fileList.forEach((item) => {
        this.fileUploadImgList.push('public/picture/agent/' + this.getUid() + '_' + item.file.lastModified + '/' + item.file.name)
      })

      // 去重
      const arrSet = [...new Set(this.fileUploadImgList)]
      const params = {
        contactWay: this.contact,
        country: this.youFrom,
        otherWorkingPlatform: this.theyFrom,
        otherWorkingPlatformIncomeImage: arrSet,
      }

      this.isSubmitting = true
      apiAgentApply(params)
        .then((res) => {
          if (res.status == 200) {
            this.$client.showToast(res.message)
            this.fileUploadImgList.length = 0
            this.youFrom = null
            this.theyFrom = null
            this.contact = null
            this.fileList.length = 0
            this.fileList = []
          }
          // 异常处理
          else {
            this.fileUploadImgList.length = 0
            this.fileList.length = 0
            this.fileList = []
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    getBeforeUploadInfo() {
      getAwsInfoApi().then((resData) => {
        try {
          const jsonObj = JSON.parse(decryptCode(resData, SecretKey.pk))
          // AWS 认证相关
          this.s3 = new AWS.S3({
            accessKeyId: jsonObj.accessKeyId,
            secretAccessKey: jsonObj.secretAccessKey,
            region: jsonObj.region,
          })
        } catch (err) {
          console.log('try catch', err)
        }
      })
    },
  },
  created() {
    this.getBeforeUploadInfo()
    this.fetchUserAccountInfo()
  },
}
</script>
<style lang="scss" scoped>
.container-become-agent {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;

  .custom-nav-block {
    background-color: #ffffff;
    .van-bar {
      ::v-deep .van-nav-bar__left .tit-left {
        font-family: var(--string-font);
        font-size: var(--fs-20);
        font-weight: var(--fw-900);
        line-height: var(--lh-title-24);
        color: #333333;
      }
    }
  }

  // iOS 特定样式
  @supports (-webkit-touch-callout: none) {
    /* iOS Safari 特有样式 */
    height: -webkit-fill-available;
  }

  // 输入框获得焦点时的特殊处理
  input:focus {
    // 激活硬件加速
    transform: translateZ(0);
  }

  .main {
    overflow: hidden;
    padding: 0 16px;
    // 添加安全区域适配
    padding-bottom: env(safe-area-inset-bottom);
  }
  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: var(--string-font);
    font-size: var(--fs-20);
    font-weight: var(--fw-600);
    line-height: var(--lh-title-28);
    color: #000;
    margin-bottom: 26px;
    > img {
      width: 90px;
      height: 90px;
      border-radius: 10px;
      margin-bottom: 20px;
    }
  }
  .item {
    .text {
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-label-18);
      color: #333;
    }
    input {
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-label-18);
      color: #333;
      width: 100%;
      margin: 10px 0 20px 0;
      padding: 5px;
      border-bottom: 1px solid #ccc;
    }
  }
  .item:nth-of-type(5) {
    .text {
      margin-bottom: 10px;
    }
  }
  .submit {
    width: 200px;
    min-height: 40px;
    margin: 30px auto;
    background: linear-gradient(90deg, #e72cc5 0%, #8931fe 100%);
    border-radius: 20px;
    pointer-events: none;
    filter: grayscale(100%);

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: var(--string-font);
    font-size: var(--fs-20);
    font-weight: var(--fw-500);
    line-height: var(--lh-title-28);
    color: #fff;

    .submit-loading {
      display: inline-block;
      margin: 0 5px;
    }
  }
  .submitflag {
    pointer-events: auto;
    filter: grayscale(0);
  }
}
</style>
